/**
 * @flow
 * @relayHash 16296535d4b3ac50618aa81a01568878
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type commentForm_document$ref = any;
export type DocumentStatus = "ACTIVE" | "DELETED" | "OLD" | "OLD_SAVE" | "PENDING" | "RETIRED" | "SAVED" | "SCHEDULED" | "%future added value";
export type EditPolicyQueryVariables = {|
  documentPk: number,
  continueDraft?: ?boolean,
|};
export type EditPolicyQueryResponse = {|
  +documentEdit: ?{|
    +document: ?{|
      +id: string,
      +pk: ?number,
      +name: string,
      +status: ?DocumentStatus,
      +actions: ?$ReadOnlyArray<?{|
        +id: string,
        +pk: ?number,
        +actionType: string,
        +actionDate: any,
        +comment: string,
        +canEdit: ?boolean,
        +isExternal: boolean,
        +user: ?{|
          +id: string,
          +userDisplay: ?string,
        |},
      |}>,
      +$fragmentRefs: commentForm_document$ref,
    |},
    +documentSave: ?{|
      +pk: ?number,
      +savedCopy: ?{|
        +pk: ?number,
        +author: {|
          +pk: ?number,
          +firstName: string,
          +lastName: string,
          +email: string,
        |},
      |},
    |},
    +editForm: ?{|
      +name: ?string,
      +author: ?{|
        +pk: ?number,
        +firstName: string,
        +lastName: string,
        +title: ?string,
      |},
      +category: ?{|
        +pk: ?number,
        +name: string,
      |},
      +categoryChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +flowTemplate: ?{|
        +pk: ?number,
        +name: ?string,
      |},
      +flowTemplateChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: ?string,
      |}>,
      +bloc: ?{|
        +pk: ?number,
        +name: string,
      |},
      +blocChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +html: ?string,
      +activeLifespan: ?number,
      +expirationDate: ?string,
      +isAForm: ?boolean,
      +restricted: ?boolean,
      +regulations: ?$ReadOnlyArray<?number>,
    |},
    +tagForm: ?{|
      +tags: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>
    |},
    +saveForm: ?{|
      +hasSavedCopy: ?boolean,
      +continueDraft: ?boolean,
      +timestamp: ?string,
    |},
    +scheduledEffectiveDateForm: ?{|
      +effectiveDate: ?string,
      +effectiveDateTimedelta: ?number,
      +effectiveDateAlgorithm: ?string,
    |},
    +alreadyChanged: ?boolean,
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
    +tenantsToRedirect: ?$ReadOnlyArray<?{|
      +name: string,
      +url: ?string,
    |}>,
    +rtlSupport: ?boolean,
    +newCkeditor: ?boolean,
    +redirectUrl: ?string,
    +policyActions: ?any,
  |}
|};
export type EditPolicyQuery = {|
  variables: EditPolicyQueryVariables,
  response: EditPolicyQueryResponse,
|};
*/


/*
query EditPolicyQuery(
  $documentPk: Int!
  $continueDraft: Boolean
) {
  documentEdit(pk: $documentPk, continueDraft: $continueDraft) {
    document {
      ...commentForm_document
      id
      pk
      name
      status
      actions(isEditPage: true) {
        id
        pk
        actionType
        actionDate
        comment
        canEdit
        isExternal
        user {
          id
          userDisplay(userDisplayType: FORWARD)
        }
      }
    }
    documentSave {
      pk
      savedCopy {
        pk
        author {
          pk
          firstName
          lastName
          email
          id
        }
        id
      }
      id
    }
    editForm {
      name
      author {
        pk
        firstName
        lastName
        title
        id
      }
      category {
        pk
        name
        id
      }
      categoryChoices {
        pk
        name
        id
      }
      flowTemplate {
        pk
        name
        id
      }
      flowTemplateChoices {
        pk
        name
        id
      }
      bloc {
        pk
        name
        id
      }
      blocChoices {
        pk
        name
        id
      }
      html
      activeLifespan
      expirationDate
      isAForm
      restricted
      regulations
    }
    tagForm {
      tags {
        pk
        name
        id
      }
    }
    saveForm {
      hasSavedCopy
      continueDraft
      timestamp
    }
    scheduledEffectiveDateForm {
      effectiveDate
      effectiveDateTimedelta
      effectiveDateAlgorithm
    }
    alreadyChanged
    error {
      statusCode
      message
    }
    tenantsToRedirect {
      name
      url
      id
    }
    rtlSupport
    newCkeditor
    redirectUrl
    policyActions
  }
}

fragment commentForm_document on DocumentType {
  id
  pk
  canComment
  subscribedToComments
  usersNotificationComment {
    usersNotificationCommentOn {
      pk
      firstName
      lastName
      id
    }
    usersNotificationCommentOff {
      pk
      firstName
      lastName
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "documentPk",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "continueDraft",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "continueDraft",
    "variableName": "continueDraft",
    "type": "Boolean"
  },
  {
    "kind": "Variable",
    "name": "pk",
    "variableName": "documentPk",
    "type": "Int!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "actions",
  "storageKey": "actions(isEditPage:true)",
  "args": [
    {
      "kind": "Literal",
      "name": "isEditPage",
      "value": true,
      "type": "Boolean"
    }
  ],
  "concreteType": "DocumentActionType",
  "plural": true,
  "selections": [
    v2,
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "actionType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "actionDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "comment",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canEdit",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isExternal",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "ApprovalStepUserType",
      "plural": false,
      "selections": [
        v2,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "userDisplay",
          "args": [
            {
              "kind": "Literal",
              "name": "userDisplayType",
              "value": "FORWARD",
              "type": "UserDisplayType"
            }
          ],
          "storageKey": "userDisplay(userDisplayType:\"FORWARD\")"
        }
      ]
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v11 = [
  v3,
  v4
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "html",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "activeLifespan",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAForm",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regulations",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "saveForm",
  "storageKey": null,
  "args": null,
  "concreteType": "DocumentSaveFormType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasSavedCopy",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "continueDraft",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    }
  ]
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "scheduledEffectiveDateForm",
  "storageKey": null,
  "args": null,
  "concreteType": "ScheduledEffectiveDateForm",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDateTimedelta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDateAlgorithm",
      "args": null,
      "storageKey": null
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alreadyChanged",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rtlSupport",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "newCkeditor",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "redirectUrl",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "policyActions",
  "args": null,
  "storageKey": null
},
v27 = [
  v3,
  v7,
  v8,
  v2
],
v28 = [
  v3,
  v4,
  v2
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "EditPolicyQuery",
  "id": "814ef14652e0299fc379d0dd11e25450",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "EditPolicyQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentEdit",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentEditType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "commentForm_document",
                "args": null
              },
              v2,
              v3,
              v4,
              v5,
              v6
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentSave",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentSaveType",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "savedCopy",
                "storageKey": null,
                "args": null,
                "concreteType": "RLDatixDocumentType",
                "plural": false,
                "selections": [
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "author",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ApprovalStepUserType",
                    "plural": false,
                    "selections": [
                      v3,
                      v7,
                      v8,
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "editForm",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentFormType",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v3,
                  v7,
                  v8,
                  v10
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": true,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplateChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": true,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v11
              },
              v12,
              v13,
              v14,
              v15,
              v16,
              v17
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tagForm",
            "storageKey": null,
            "args": null,
            "concreteType": "TagFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v11
              }
            ]
          },
          v18,
          v19,
          v20,
          v21,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantsToRedirect",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantType",
            "plural": true,
            "selections": [
              v4,
              v22
            ]
          },
          v23,
          v24,
          v25,
          v26
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EditPolicyQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentEdit",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentEditType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canComment",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subscribedToComments",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "usersNotificationComment",
                "storageKey": null,
                "args": null,
                "concreteType": "UserCommentNotificationType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usersNotificationCommentOn",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": true,
                    "selections": v27
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usersNotificationCommentOff",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": true,
                    "selections": v27
                  }
                ]
              },
              v4,
              v5,
              v6
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentSave",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentSaveType",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "savedCopy",
                "storageKey": null,
                "args": null,
                "concreteType": "RLDatixDocumentType",
                "plural": false,
                "selections": [
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "author",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ApprovalStepUserType",
                    "plural": false,
                    "selections": [
                      v3,
                      v7,
                      v8,
                      v9,
                      v2
                    ]
                  },
                  v2
                ]
              },
              v2
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "editForm",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentFormType",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v3,
                  v7,
                  v8,
                  v10,
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v28
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": true,
                "selections": v28
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": v28
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplateChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": true,
                "selections": v28
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": v28
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v28
              },
              v12,
              v13,
              v14,
              v15,
              v16,
              v17
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tagForm",
            "storageKey": null,
            "args": null,
            "concreteType": "TagFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v28
              }
            ]
          },
          v18,
          v19,
          v20,
          v21,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantsToRedirect",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantType",
            "plural": true,
            "selections": [
              v4,
              v22,
              v2
            ]
          },
          v23,
          v24,
          v25,
          v26
        ]
      }
    ]
  }
};
})();
node.text = "query EditPolicyQuery(\n  $documentPk: Int!\n  $continueDraft: Boolean\n) {\n  documentEdit(pk: $documentPk, continueDraft: $continueDraft) {\n    document {\n      ...commentForm_document\n      id\n      pk\n      name\n      status\n      actions(isEditPage: true) {\n        id\n        pk\n        actionType\n        actionDate\n        comment\n        canEdit\n        isExternal\n        user {\n          id\n          userDisplay(userDisplayType: FORWARD)\n        }\n      }\n    }\n    documentSave {\n      pk\n      savedCopy {\n        pk\n        author {\n          pk\n          firstName\n          lastName\n          email\n          id\n        }\n        id\n      }\n      id\n    }\n    editForm {\n      name\n      author {\n        pk\n        firstName\n        lastName\n        title\n        id\n      }\n      category {\n        pk\n        name\n        id\n      }\n      categoryChoices {\n        pk\n        name\n        id\n      }\n      flowTemplate {\n        pk\n        name\n        id\n      }\n      flowTemplateChoices {\n        pk\n        name\n        id\n      }\n      bloc {\n        pk\n        name\n        id\n      }\n      blocChoices {\n        pk\n        name\n        id\n      }\n      html\n      activeLifespan\n      expirationDate\n      isAForm\n      restricted\n      regulations\n    }\n    tagForm {\n      tags {\n        pk\n        name\n        id\n      }\n    }\n    saveForm {\n      hasSavedCopy\n      continueDraft\n      timestamp\n    }\n    scheduledEffectiveDateForm {\n      effectiveDate\n      effectiveDateTimedelta\n      effectiveDateAlgorithm\n    }\n    alreadyChanged\n    error {\n      statusCode\n      message\n    }\n    tenantsToRedirect {\n      name\n      url\n      id\n    }\n    rtlSupport\n    newCkeditor\n    redirectUrl\n    policyActions\n  }\n}\n\nfragment commentForm_document on DocumentType {\n  id\n  pk\n  canComment\n  subscribedToComments\n  usersNotificationComment {\n    usersNotificationCommentOn {\n      pk\n      firstName\n      lastName\n      id\n    }\n    usersNotificationCommentOff {\n      pk\n      firstName\n      lastName\n      id\n    }\n  }\n}\n";
(node/*: any*/).hash = 'a0dc071922f225716069045f6140405f';
module.exports = node;
